module.exports = __webpack_public_path__ + "static/badge-171ba4158e34c8f6c715c1c131fabf40.png";